<script setup>

/**
 * Требования к паролю связаны с хелпером проверки паролей ./helpers/checkValue.js (mode = pass)
 */

import { computed, ref, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()

const props = defineProps({
    password: {
        type: String,
        required: true
    }
})

const minLength     = 8             // Минимальная длинна пароля
const goodLength    = 10            // Кол-во символов для надёжного пароля
const maxLength     = 256           // Максимальная длинна пароля
const needLetters   = true          // Минимум одна строчная и одна заглавная литинские буквы
const needNumber    = true          // Минимум одна цифра
const needSymbol    = true          // Минимум один символ
const passIndicator = ref('low')    // Модификатор класса для маркировки индикатора
const errorText     = ref('')

const getTranslate = computed(() => translaterStore.getTranslate)
const password = computed(() => props.password)

function checkPass(inputPass) {

    errorText.value = ''

    if(
        inputPass.length < minLength || 
        inputPass.length > maxLength
    ) {

        errorText.value = 'PASS_INDICATOR_E_LENGHT'
        passIndicator.value = 'low'
        return false
    }

    if(needLetters) {
        if(!/^.*(?=.[a-z])(?=.*[A-Z]).*$/.test(inputPass)) {
            errorText.value = 'PASS_INDICATOR_E_LETTER'
            passIndicator.value = 'low'
            return false
        }
    }

    if(needNumber) {
        if(!/[0-9]{1,}/.test(inputPass)) {
            errorText.value = 'PASS_INDICATOR_E_NUMBER'
            passIndicator.value = 'low'
            return false
        }
    }

    if(needSymbol) {
        if(!/[_\-%&]/.test(inputPass)) {
            errorText.value = 'PASS_INDICATOR_E_SYMBOL'
            passIndicator.value = 'low'
            return false
        }
    }

    passIndicator.value = 'middle'

    if(inputPass.length >= goodLength) {
        passIndicator.value = 'high'
    }

    return true
}

watch(password, data => {
    checkPass(data)
})

</script>

<template>
    <div class="mt-n4 mb-4 pass-indicator">
        <div class="pass-indicator__line">
            <div 
                class="pass-indicator__line-level"
                :class="{ 
                    'pass-indicator__line-level--low'    : passIndicator == 'low', 
                    'pass-indicator__line-level--middle' : passIndicator == 'middle', 
                    'pass-indicator__line-level--high'   : passIndicator == 'high'
                }"
            ></div>
        </div>
        <div class="pass-indicator__error">
            {{ getTranslate[errorText] }}
        </div>
        <div class="pass-indicator__descr">
            {{ getTranslate.PASS_INDICATOR_DESCR }}
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/pass-indicator.scss';
</style>